import { ChannelItemStatus } from '../enums/ChannelItemStatus';
import { ChannelItemUnion } from '../types/ChannelItem';

export function getFriendlyStatus(status: ChannelItemStatus) {
    switch (status) {
        case ChannelItemStatus.Scheduled:
            return 'Scheduled';
        case ChannelItemStatus.Completed:
            return 'Completed';
        case ChannelItemStatus.Failed:
            return 'Failed';
        case ChannelItemStatus.Sending:
            return 'Sending';
        default:
            return `Unknown (${status})`;
    }
}

///merge new channel items into the existing channelItems list, replacing items with matching keys
export function mergeChannelIndexItems(oldItems: ChannelItemUnion[], newItems: ChannelItemUnion[]) {
    newItems.forEach(newItem => {
        const itemIndex = oldItems.findIndex(o => o.id === newItem.id);
        if (itemIndex > -1) {
            oldItems[itemIndex] = newItem;
        } else {
            oldItems.push(newItem);
        }
    });

    return [...oldItems].sort(sortChannelItemByDate);
}

export function sortChannelItemByDate(a: ChannelItemUnion, b: ChannelItemUnion): number {
    return Number(new Date(b.date)) - Number(new Date(a.date));
}
